import CircleIcon from "@mui/icons-material/Circle";
import { Chip, chipClasses, Typography } from "@mui/material";
import { labToCss } from "service/color-math";
import type { OemColorValue } from "../filter/color-filter/oem-color";
import type { FilterChipProps } from "./FilterChips";

export const OemColorFilterChip = ({
  value,
  label,
  ...props
}: FilterChipProps<OemColorValue>) => {
  const text = [value.library, value.code, value.name]
    .filter(Boolean)
    .join(" / ");
  return (
    <Chip
      sx={{
        [`& .${chipClasses.icon}`]: {
          color: value.cieLab ? labToCss(value.cieLab) : "text.secondary",
        },
      }}
      icon={
        value.cieLab ? (
          <CircleIcon />
        ) : (
          <Typography component="span" fontWeight="bold" aria-label="?">
            ?
          </Typography>
        )
      }
      label={`${label}: ${text}`}
      {...props}
    />
  );
};
